import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const MobileOtpVerify = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [validated, setValidated] = useState(false);

  const [serverResponse, setServerResponse] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.VERIFY_LOGIN_OTP, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
          context.saveLogin(
            res["data"].data,
            res["data"].api,
            res["data"].permissions,
            []
          );
          context.updateAcyear(res["data"].acyear);

          context.updateLogged();
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
        }
        setLoader(false);
      });
  };

  const resetPass = () => {
    context.updateMobilePassword("");
    context.updateMobileUserId("");
    if (props.onReset) props.onReset();
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="container-sm" data-aos="zoom-in">
          <div className="login-img d-flex justify-content-center align-content-center">
            <img
              className="ms-3"
              src={MOB_ICONS.PASSWORD_256}
              style={{ width: "100%", maxWidth: "120px" }}
            />
          </div>

          <div className="login my-4">
            <h2 className="fw-bold text-center">Verify OTP</h2>
            <p className="text-center">Enter your verification code</p>
          </div>

          {/* <div className=" border-0">
            <div style={{ minHeight: "100px" }} className="px-4">
              <div style={{ paddingTop: "40px" }}>
                <h2 className="fw-bold">Verify OTP</h2>
                Enter your verification code
              </div>
              <img src={MOB_ICONS.PASSWORD_256} className="mob_login_top_img" />
            </div>
          </div> */}

          <div className="px-3">
            <Form
              action=""
              method="post"
              noValidate
              validated={validated}
              onSubmit={handleFormSubmit}
            >
              <input type="hidden" name="device_name" value={"kalvisalai"} />
              <input
                type="hidden"
                name="device_build_id"
                value={"kalvisalai"}
              />
              <input type="hidden" name="staff_uuid" value={props.staffUuid} />

              <input
                type="hidden"
                name="emp_mobile_password"
                value={context.mobPass}
              />
              <Row className="mt-3">
                <Col md={12}>
                  <Form.Control
                    type="number"
                    name="otp"
                    className="fw-bold"
                    size="lg"
                    placeholder="One Time Password"
                    autoFocus
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    OTP is required
                  </Form.Control.Feedback>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="btn-block text-uppercase bg-theme"
                    size="lg"
                    variant="danger"
                    disabled={loader}
                  >
                    {loader ? "Validating..." : "Validate"}
                    {loader && (
                      <Spinner
                        animation="grow"
                        size="sm"
                        state="loading"
                        className="ms-3"
                      />
                    )}
                  </Button>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col
                  md={12}
                  className="d-flex justify-content-center align-content-center"
                >
                  <a onClick={(e) => resetPass()}>
                    <span className="text-black fs-6 me-1">
                      Didn't receive the OTP ?
                    </span>
                    <span className="theme-text fs-5 ">Resend</span>
                  </a>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
export default MobileOtpVerify;
